import { InjectionMode } from './InjectionMode';

export function getPageData<T extends BasePageModel>(): T {
  const container = document.getElementById('main-app');
  const pageData: T = {
    ...JSON.parse(container.dataset.model),
    ApiBaseUrl: container.dataset.baseurl,
    LogoUri: (document.getElementById('logo-image-link') as HTMLLinkElement)?.href,
  };

  if (Object.hasOwn(pageData, 'TransactionAttributes')) {
    pageData['TransactionAttributes'] = pageData['TransactionAttributes'] || [];
  }

  return { ...pageData };
}

export type BasePageModel = {
  ApiBaseUrl: string;
  LogoUri: string;
  AccountName: string;
  Subdomain: string;
  GoogleDataSiteClientKey: string;
  GoogleDataSiteClientKeyV3: string;
  GoogleDataSiteInvisibleClientKey: string;
  PaymentPageBannerText?: string;
  IsAuthenticated: boolean;
  MixpanelToken: string;
  InjectionMode: InjectionMode;
  DisableMixpanel: boolean;
  DisablePaymentPage: boolean;
  MixpanelProxyUrl: string;
};
